<div class="error-page">
    <form>
        <div class="container">
            <div class="text-center">
                <h2>Something went wrong please contact administrator</h2>
            </div>            
        </div>
    </form>
</div>